module.exports = __webpack_public_path__ + "img/ic_saberes_cross.31042410.svg";